export default "__VITE_ASSET__4tScWb0t__"